/* Emekten Sofraya — mobil çekmece "Tüm Kategoriler" alt paneli.
   "Tüm Kategoriler" öğesine dokununca sağdan kayan bir alt panel açar:
   üstte "Ana menü" geri butonu + başlık + kapat, altında "Tüm Kategorileri Gör →",
   altında tek sütunlu kategori listesi. Tema Liquid'ine dokunmadan çalışır. */
(function () {
  window.__esMenuDrawer = { loaded: true, built: false };

  var TRIGGER_ID = 'HeaderDrawer-tum-kategoriler';
  var PANEL_ID = 'link-tum-kategoriler';
  var isOpen = false;

  function setClosed(panel) {
    panel.style.setProperty('transform', 'translateX(100%)', 'important');
    panel.style.setProperty('opacity', '0', 'important');
    panel.style.removeProperty('visibility');
  }
  function setOpen(panel) {
    panel.style.setProperty('transform', 'translateX(0)', 'important');
    panel.style.setProperty('visibility', 'visible', 'important');
    panel.style.setProperty('opacity', '1', 'important');
  }

  function build() {
    var trigger = document.getElementById(TRIGGER_ID);
    if (!trigger) return false;

    var existing = document.getElementById(PANEL_ID);
    if (existing) {
      trigger.setAttribute('data-es-panel', '1');
      var li0 = trigger.closest('li');
      if (li0) {
        li0.classList.add('es-subpanel');
        li0.classList.remove('menu-drawer__list-item--flat');
        li0.classList.toggle('es-subpanel--open', isOpen);
      }
      if (isOpen) setOpen(existing); else setClosed(existing);
      return true;
    }

    var li = trigger.closest('li');
    var drawer = trigger.closest('.menu-drawer');
    var childlist = li && li.querySelector('.menu-drawer__menu--childlist');
    if (!li || !drawer || !childlist) return false;

    trigger.setAttribute('data-es-panel', '1');
    li.classList.add('es-subpanel');
    li.classList.remove('menu-drawer__list-item--flat');

    var titleText =
      (trigger.querySelector('.menu-drawer__menu-item-text') || {}).textContent ||
      'Tüm Kategoriler';
    var caretDown =
      '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false">' +
      '<path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var closeX =
      '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false">' +
      '<path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round"/></svg>';

    var panel = document.createElement('div');
    panel.className = 'menu-drawer__submenu es-subpanel__view';
    panel.id = PANEL_ID;
    panel.setAttribute('tabindex', '-1');
    setClosed(panel);

    var nav = document.createElement('div');
    nav.className =
      'menu-drawer__nav-buttons menu-drawer__nav-buttons--with-title es-subpanel__nav';
    nav.innerHTML =
      '<button type="button" class="button menu-drawer__back-button focus-inset es-subpanel__back" aria-label="Ana menü">' +
      '<span class="svg-wrapper icon-caret icon-caret--backward">' + caretDown + '</span>' +
      '<span class="es-subpanel__back-text">Ana menü</span>' +
      '</button>' +
      '<a href="' + (trigger.getAttribute('href') || '#') +
      '" class="menu-drawer__title focus-inset"><span class="menu-drawer__menu-item-text">' +
      titleText + '</span></a>' +
      '<button type="button" class="button close-button menu-drawer__close-button focus-inset es-subpanel__close" aria-label="Kapat">' +
      '<span class="svg-wrapper">' + closeX + '</span></button>';

    childlist.parentNode.insertBefore(panel, childlist);
    panel.appendChild(nav);
    panel.appendChild(childlist);
    childlist.classList.remove('menu-drawer__menu--grid');

    if (!trigger.querySelector('.es-subpanel__caret')) {
      var caret = document.createElement('span');
      caret.className = 'svg-wrapper icon-caret icon-caret--forward es-subpanel__caret';
      caret.innerHTML = caretDown;
      trigger.appendChild(caret);
    }

    function openPanel(e) {
      if (e) e.preventDefault();
      isOpen = true;
      li.classList.add('es-subpanel--open');
      drawer.classList.add('menu-drawer--has-submenu-opened');
      setOpen(panel);
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }
    function closePanel() {
      isOpen = false;
      li.classList.remove('es-subpanel--open');
      drawer.classList.remove('menu-drawer--has-submenu-opened');
      setClosed(panel);
      trigger.focus();
    }

    trigger.setAttribute('role', 'button');
    trigger.addEventListener('click', openPanel);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') openPanel(e);
    });
    nav.querySelector('.es-subpanel__back').addEventListener('click', closePanel);
    nav.querySelector('.es-subpanel__close').addEventListener('click', function () {
      isOpen = false;
      li.classList.remove('es-subpanel--open');
      setClosed(panel);
      var realClose = drawer.querySelector(
        ':scope > .menu-drawer__close-button, :scope .header__icon--summary'
      );
      if (realClose) realClose.click();
    });

    var details = drawer.closest('details');
    if (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) closePanel();
      });
    }

    window.__esMenuDrawer.built = true;
    return true;
  }

  function safeBuild() {
    try { return build(); } catch (e) { return false; }
  }

  safeBuild();
  document.addEventListener('DOMContentLoaded', safeBuild);
  window.addEventListener('load', safeBuild);
  window.addEventListener('pageshow', safeBuild);
  document.addEventListener('shopify:section:load', safeBuild);

  var tries = 0;
  var iv = setInterval(function () {
    safeBuild();
    if (++tries > 50) clearInterval(iv);
  }, 250);

  var mo = new MutationObserver(function () {
    var t = document.getElementById(TRIGGER_ID);
    if (t && (t.getAttribute('data-es-panel') !== '1' || !document.getElementById(PANEL_ID))) {
      safeBuild();
    }
  });
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-es-panel']
  });
})();
